"use strict";

const CustomerTypes = {
  BrandAffiliate: "BrandAffiliate",
  Preferred: "Preferred",
  PreferredCustomer: "Preferred Customer",
  Retail: "Retail",
  properties: {
    BRAND_AFFILIATE: { stringKey: "DIST", code: 10 },
    RETAIL: { stringKey: "CUST", code: 20 },
    PREFERRED: { stringKey: "preferred", code: 30 },
    PREFERRED_CUSTOMER: { stringKey: "PREF", code: 30 }
  }
};

module.exports = CustomerTypes;
